// extracted by mini-css-extract-plugin
module.exports = {"links":"SocialLinks_links__qfTDz","socialLink":"SocialLinks_socialLink__3FFYt"};